// libs
import React, { forwardRef, memo, useRef } from 'react';
import isEmpty from 'lodash/isEmpty';

// components
import SizeButton from 'shared/layouts/DetailsPage/components/ProductInfo/components/SizeOptions/components/SizeButton';

// constants
import { TEXTS } from './texts';

// styles
import {
  BodyMeasContainer,
  BodyMeasTitle,
  BodyPart,
  SizeBtnContainer,
  SizeOptionContainer,
} from './styles';

//types
import { ReqElement } from 'components/Input/BaseInput/types';

export interface ISizeOptionProps {
  sizeOptions: ProductDetail.IProduct['sizeOptions'];
  onSelect: (size: ProductDetail.ISizeOption) => void;
  isOneSize: boolean;
  shake?: boolean;
  canShowPDPMeasurements: boolean;
  currentSize?: ProductDetail.ISizeOption;
  hideBodyMeasurements?: boolean;
  className?: string;
  children: React.ReactNode;
}

const SizeOptions = (
  {
    sizeOptions,
    onSelect,
    isOneSize,
    shake,
    canShowPDPMeasurements,
    currentSize,
    hideBodyMeasurements,
    className = '',
    children = null,
  }: ISizeOptionProps,
  ref: React.RefObject<ReqElement>
) => {
  const contRef = useRef<HTMLDivElement>(null);

  if (isEmpty(sizeOptions) || isOneSize) {
    return null;
  }
  const { options } = sizeOptions;
  const canShowBodyMeasurements =
    canShowPDPMeasurements &&
    hideBodyMeasurements === false &&
    currentSize !== undefined &&
    currentSize.bodyMeasurements;
  return (
    <SizeOptionContainer ref={ref} className={className} data-test="size-options" shake={shake}>
      {canShowBodyMeasurements && (
        <BodyMeasContainer>
          <BodyMeasTitle data-test="size-name">
            {TEXTS.MEASUREMENT_FOR(currentSize.sizeName)}
          </BodyMeasTitle>
          {currentSize.bodyMeasurements.map((size, i) => {
            return (
              <BodyPart key={i} data-test="body-part">
                {size.title}: {size.value}&quot;
              </BodyPart>
            );
          })}
        </BodyMeasContainer>
      )}

      <SizeBtnContainer className="size-btn-container" ref={contRef}>
        {children}
        {options.map((sizeOption, i) => {
          const isSelected = currentSize !== undefined && currentSize.sku === sizeOption.sku;

          return (
            <SizeButton
              key={i}
              onClick={() => {
                onSelect(sizeOption);
              }}
              isSelected={isSelected}
              isOutOfStock={sizeOption.isOutOfStock === 1}
              size={sizeOption.sizeName}
              containerRef={contRef}
              stockRemaining={sizeOption.stock_remaining}
            />
          );
        })}
      </SizeBtnContainer>
    </SizeOptionContainer>
  );
};

export default memo(forwardRef(SizeOptions));
